import {PaymentStatus} from "./types";
import {StatusStyle} from "../../../components/portal/StatusBadge";

export const getStyleFromPaymentStatus = (status: PaymentStatus): StatusStyle => ({
  'paid': ('success' as StatusStyle),
  'pending': ('warning' as StatusStyle),
  'unpaid': ('danger' as StatusStyle),
  'voided': ('danger' as StatusStyle)
}[status]);
